/**
 * 'YYYY-MM-DDTHH:MM' 또는 'YYYY-MM-DDTHH:MM:SS' 형태의 datetime-local 문자열을 UTC 기준 Date로 파싱
 */
export const parseDateTimeLocalAsUTC = (datetimeLocal: string): Date | null => {
  if (!datetimeLocal) return null;
  
  // 초 단위 형식 시도 (YYYY-MM-DDTHH:MM:SS)
  let match = datetimeLocal.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/);
  if (match) {
    const [, y, m, d, hh, mm, ss] = match;
    const date = new Date(Date.UTC(Number(y), Number(m) - 1, Number(d), Number(hh), Number(mm), Number(ss)));
    if (isNaN(date.getTime())) return null;
    return date;
  }
  
  // 분 단위 형식 시도 (YYYY-MM-DDTHH:MM)
  match = datetimeLocal.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/);
  if (match) {
    const [, y, m, d, hh, mm] = match;
    const date = new Date(Date.UTC(Number(y), Number(m) - 1, Number(d), Number(hh), Number(mm)));
    if (isNaN(date.getTime())) return null;
    return date;
  }
  
  return null;
};

/**
 * UTC로 해석한 입력을 타임존 키 포맷(YYYY-MM-DDTHH:MM:SS)으로 표시
 */
export const formatUTCInputToTZKey = (datetimeLocalUTC: string, timeZone: string): string => {
  const d = parseDateTimeLocalAsUTC(datetimeLocalUTC);
  if (!d) return '';
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
  const parts = formatter.formatToParts(d);
  const get = (type: string) => parts.find(p => p.type === type)?.value || '';
  const yyyy = get('year');
  const mm = get('month');
  const dd = get('day');
  const hh = get('hour');
  const mi = get('minute');
  const ss = get('second');
  return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}`;
};
